module.exports = "https://cdn01.riselinkedu.com/assets/lottie/img_0.9c6d044e.png";